import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromImei from './+state/imei.reducer';
import { EffectsModule } from '@ngrx/effects';
import { ImeiEffects } from './+state/imei.effects';
import { ImeiApiService } from './services/imei-api.service';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromImei.IMEI_FEATURE_KEY, fromImei.imeiReducer),
    EffectsModule.forFeature([ImeiEffects]),
  ],
  providers: [ImeiApiService],
})
export class SkyDataAccessImeiModule {}
